import { render, staticRenderFns } from "./SupportNotice.vue?vue&type=template&id=9f221d40&scoped=true"
import script from "./SupportNotice.vue?vue&type=script&lang=js"
export * from "./SupportNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f221d40",
  null
  
)

export default component.exports